import React, { useEffect } from 'react';
import tempImg from '../../static/icons/aftex-fix.png';

export const Temp = (props) => {
  useEffect(() => {
    props.hideLoader();
  }, [props]);

  return <img src={tempImg} alt="" className="mx-auto full-image" />;
};
